"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMobileName = exports.getFilterMenuList = exports.getDefaultMenuByDepth = exports.getVisibleDepthMenus = exports.normalizeHiddenMenus = exports.menuItems = exports.getDepths = exports.getMenuData = void 0;
const regist_1 = require("../../redux/regist");
const constant_1 = require("../DST/constant");
const getMenuData = (statful) => {
    const state = (0, regist_1.toState)(statful);
    return {
        depths: state['base/menu'].depths,
        menu: state['base/menu'].menu,
        id: state['base/menu'].id,
        props: state['base/menu'].props,
    };
};
exports.getMenuData = getMenuData;
const getDepths = (statful) => {
    const state = (0, regist_1.toState)(statful);
    return state['base/menu'].depths;
};
exports.getDepths = getDepths;
// 각 메뉴의 세부 항목 정의
exports.menuItems = {
    learningManagement: ['test', 'assignment', 'attendanceStatus'],
    myRoom: ['test', 'assignment', 'gradeCard'],
    liveRoom: ['reservation', 'previous-conference', 'replay', 'content'],
    learningSupportRoom: ['qna', 'resource', 'survey', 'sendSMS'],
    notice: ['notice'],
};
const LEGACY_MENU_ID_MAP = {
    assginment: 'assignment',
    attendance: 'attendanceStatus',
    sms: 'sendSMS',
};
const CANONICAL_MENU_IDS = new Set([
    'assignment',
    'test',
    'attendanceStatus',
    'sendSMS',
    'gradeCard',
    'notice',
    'qna',
    'resource',
    'survey',
    'reservation',
    'previous-conference',
    'replay',
    'replay-teacher',
    'replay-student',
    'content',
]);
const normalizedHiddenMenuCache = new WeakMap();
const EMPTY_HIDDEN_MENUS = [];
const getDepthOrder = (isTeacher) => {
    return (isTeacher ? constant_1.DEFAULT_MENU_T_LIST : constant_1.DEFAULT_MENU_S_LIST);
};
const getDepthMenus = (depth, isTeacher) => {
    switch (depth) {
        case 'learningManagement':
            return [...exports.menuItems.learningManagement];
        case 'myRoom':
            return [...exports.menuItems.myRoom];
        case 'learningSupportRoom':
            return isTeacher
                ? [...exports.menuItems.learningSupportRoom]
                : exports.menuItems.learningSupportRoom.filter(menu => menu !== 'sendSMS');
        case 'notice':
            return [];
        case 'liveRoom':
            return isTeacher ? [...exports.menuItems.liveRoom] : [];
        default:
            return [];
    }
};
const normalizeHiddenMenus = (hiddenMenus = [], options = {}) => {
    const { dropUnknown = false } = options;
    if (hiddenMenus.length === 0)
        return EMPTY_HIDDEN_MENUS;
    if (!dropUnknown) {
        const cached = normalizedHiddenMenuCache.get(hiddenMenus);
        if (cached)
            return cached;
    }
    let isChanged = false;
    const normalized = hiddenMenus
        .map(menu => {
        const mapped = LEGACY_MENU_ID_MAP[menu] || menu;
        if (mapped !== menu)
            isChanged = true;
        return mapped;
    })
        .filter(menu => (dropUnknown ? CANONICAL_MENU_IDS.has(menu) : true));
    const deduped = [...new Set(normalized)];
    if (!dropUnknown && !isChanged && deduped.length === hiddenMenus.length) {
        normalizedHiddenMenuCache.set(hiddenMenus, hiddenMenus);
        return hiddenMenus;
    }
    if (!dropUnknown) {
        normalizedHiddenMenuCache.set(hiddenMenus, deduped);
    }
    return deduped;
};
exports.normalizeHiddenMenus = normalizeHiddenMenus;
const getVisibleDepthMenus = (depth, isTeacher, hiddenMenus = []) => {
    const normalizedHiddenMenus = (0, exports.normalizeHiddenMenus)(hiddenMenus);
    const hideReplayByRole = normalizedHiddenMenus.includes('replay') ||
        (isTeacher
            ? normalizedHiddenMenus.includes('replay-teacher')
            : normalizedHiddenMenus.includes('replay-student'));
    const hiddenSet = new Set(normalizedHiddenMenus);
    if (hideReplayByRole)
        hiddenSet.add('replay');
    return getDepthMenus(depth, isTeacher).filter(menu => !hiddenSet.has(menu));
};
exports.getVisibleDepthMenus = getVisibleDepthMenus;
const getDefaultMenuByDepth = (depth, isTeacher, hiddenMenus = []) => {
    const visibleMenus = (0, exports.getVisibleDepthMenus)(depth, isTeacher, hiddenMenus);
    if (visibleMenus.length > 0)
        return visibleMenus[0];
    switch (depth) {
        case 'learningManagement':
        case 'myRoom':
            return 'test';
        case 'learningSupportRoom':
            return 'qna';
        case 'notice':
            return 'notice';
        case 'liveRoom':
            return 'reservation';
        default:
            return 'home';
    }
};
exports.getDefaultMenuByDepth = getDefaultMenuByDepth;
const getFilterMenuList = (isTeacher, hiddenMenus = []) => {
    const normalizedHiddenMenus = (0, exports.normalizeHiddenMenus)(hiddenMenus);
    const defaultMenuList = getDepthOrder(isTeacher);
    return defaultMenuList.filter((menu) => {
        switch (menu) {
            case 'learningManagement':
                return (0, exports.getVisibleDepthMenus)(menu, isTeacher, normalizedHiddenMenus).length > 0;
            case 'myRoom':
                return (0, exports.getVisibleDepthMenus)(menu, isTeacher, normalizedHiddenMenus).length > 0;
            case 'liveRoom':
                if (isTeacher)
                    return (0, exports.getVisibleDepthMenus)(menu, isTeacher, normalizedHiddenMenus).length > 0;
                const hideStudentReplay = normalizedHiddenMenus.includes('replay') ||
                    normalizedHiddenMenus.includes('replay-student');
                return (!normalizedHiddenMenus.includes('reservation') ||
                    !hideStudentReplay);
            case 'learningSupportRoom':
                return (0, exports.getVisibleDepthMenus)(menu, isTeacher, normalizedHiddenMenus).length > 0;
            case 'notice':
                return !normalizedHiddenMenus.includes('notice');
            default:
                return true;
        }
    });
};
exports.getFilterMenuList = getFilterMenuList;
const getMobileName = (statful) => {
    const state = (0, regist_1.toState)(statful);
    return state['base/menu'].name;
};
exports.getMobileName = getMobileName;
